import ParentView from '@/components/ParentView'
import Layout from '@/layout'
const PersonnelRoutes = {
  path: '/oa/Personnel',
  component: Layout,
  redirect: 'noredirect',
  name: '人事管理',
  funcPerms: 'oa:Personnel',
  meta: {
    title: '人事管理',
    icon: 'location',
    affix: false,
    noCache: true
  },
  children: [
    {
      path: 'Audit',
      component: () => import('@/views/oa/Personnel/Audit/index'),
      funcPerms: 'oa:Personnel:Audit',
      name: 'holiday',
      meta: {
        title: '审核人员配置',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'holiday',
      component: () => import('@/views/oa/Personnel/holiday/index'),
      funcPerms: 'oa:Personnel:holiday',
      name: 'holiday',
      meta: {
        title: '节假日管理',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'statistics',
      component: () => import('@/views/oa/Personnel/statistics/index'),
      funcPerms: 'oa:Personnel:statistics',
      name: 'statistics',
      meta: {
        title: '考勤统计表',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'statistics/view',
      component: () => import('@/views/oa/Personnel/statistics/view'),
      funcPerms: 'oa:Personnel:statistics',
      name: 'statistics/view',
      hidden: true,
      meta: {
        title: '考勤统计表科室查看',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'management',
      component: () => import('@/views/oa/Personnel/management/index'),
      funcPerms: 'oa:Personnel:management',
      name: 'management',
      meta: {
        title: '考勤管理',
        icon: 'index',
        affix: false,
        noCache: false
      }
    },
    {
      path: 'management/view',
      component: () => import('@/views/oa/Personnel/management/view'),
      funcPerms: 'oa:Personnel:management',
      name: 'management/view',
      hidden: true,
      meta: {
        title: '考勤管理查看',
        icon: 'index',
        affix: false,
        noCache: false
      }
    },
    {
      path: 'leave',
      component: () => import('@/views/oa/Personnel/leave/index'),
      funcPerms: 'oa:Personnel:leave',
      name: 'leave',
      meta: {
        title: '请(销)假管理',
        icon: 'index',
        affix: false,
        noCache: false
      }
    },
    {
      path: 'leave/add',
      component: () => import('@/views/oa/Personnel/leave/add'),
      funcPerms: 'oa:Personnel:leave',
      name: 'leave/add',
      hidden: true,
      meta: {
        title: '新增',
        icon: 'index',
        affix: false,
        noCache: false
      }
    },
    {
      path: 'leave/edit',
      component: () => import('@/views/oa/Personnel/leave/edit'),
      funcPerms: 'oa:Personnel:leave',
      name: 'leave/edit',
      hidden: true,
      meta: {
        title: '编辑',
        icon: 'index',
        affix: false,
        noCache: false
      }
    }
  ]
}

export default PersonnelRoutes
